import axios from 'axios';

import { toast } from 'react-toastify';
import i18next from 'i18next';
import { store } from '~/store';
import { signInSuccess, signOutRequest } from '~/store/modules/auth/actions';

let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(token) {
  subscribers = subscribers.filter(callback => callback(token));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

function getNewToken(refreshToken) {
  const url = `${process.env.REACT_APP_BASE_API_URL}/token/refresh`;
  const options = {
    withCredentials: true,
    refreshToken,
  };
  return axios.post(url, options);
}

export default function tokenInterceptor(api) {
  api.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      const config = error && error.config;
      const status = error && error.response && error.response.status;
      const originalRequest = config;
      if (originalRequest.url.includes('/confirm/')) {
        return Promise.reject(error);
      }

      if (status === 414) {
        window.localStorage.setItem('errorCode', status);
        window.location.href = `${process.env.REACT_APP_BASE_URL}/error`;
      }

      if (status === 401 || status === 403) {
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true;
          try {
            const { auth } = JSON.parse(
              localStorage.getItem('persist:@LaLiga/canal-informacion-partidos')
            );
            const { refreshToken } = JSON.parse(auth);
            getNewToken(refreshToken)
              .then(({ data }) => {
                const { token, refreshToken: rToken } = data;

                isAlreadyFetchingAccessToken = false;

                api.defaults.headers.Authorization = `Bearer ${token}`;
                store.dispatch(signInSuccess(token, rToken));

                onAccessTokenFetched(token);
              })
              .catch(() => {
                toast.error(i18next.t('sessionExpired'));
                store.dispatch(signOutRequest());
              });
          } catch (err) {
            toast.error(i18next.t('sessionExpired'));
            store.dispatch(signOutRequest());
          }
        }

        const retryOriginalRequest = new Promise(resolve => {
          addSubscriber(token => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            resolve(axios(originalRequest));
          });
        });

        return retryOriginalRequest;
      }

      return Promise.reject(error);
    }
  );
}
